<template>
    <modal v-cloak v-show="showModal" :content-popup-id="contentPopup.id">
        <div class="col-12">
            <div class="s-hide-mobile col-5-s col-5 newsLetterImage " :style="style">
            </div>
            <div class="col-5 newsLetterImage s-show-mobile">
                <img :src="contentPopup.imagePath" />
            </div>
            <div class="col-7 col-7-s col-padding-left col-padding-right m-mt10 popup-content m-p10 p10 " v-if="contentPopup.type == 0">
                <div class="title-4 line12 boldFont fontSmooth col-12 titleColor" v-text="title"></div>
                <div class="paragraph mt10 small m-mb10"  v-if="! isSend" v-html="content">

                </div>
                <div class="col-12" v-if="isSend == false">
                    <div v-if="errors.any()" class="mt10">
                        <div class="mb5 redColor"
                             v-for="error in errors.all()"
                             v-text="error"
                        ></div>
                    </div>
                    <div class="col-12">
                        <input required="required"
                               placeholder="Voornaam"
                               type="text"
                               size="30"
                               class="input mt10"
                               v-model="form.first_name"
                               @keyup="errors.remove('first_name')"
                        />
                    </div>
                    <div class="col-12">
                        <input required="required"
                               placeholder="Achternaam"
                               type="text"
                               size="30"
                               class="input mt10"
                               v-model="form.last_name"
                               @keyup="errors.remove('last_name')"
                        />
                    </div>
                    <div class="col-12">
                        <input required="required"
                               type="text"
                               size="30"
                               class="input mt10"
                               v-model="form.email"
                               placeholder="E-mailadres"
                               @keyup="errors.remove('email')"
                        />
                    </div>
                    <div class="col-12 mt20 mb10">
                        <button
                            type="button"
                            class="button blue centerText small w100p"
                            @click.prevent="subscribeNewsletter"
                            :class="{loading: isSending}"
                            :disabled="isSending"
                            v-text="buttonText"
                        >
                        </button>
                    </div>
                </div>
                <div v-else class="col-12">
                    <p class="mb30 mt10 paragraph small" v-html="contentAfter">
                    </p>
                </div>
            </div>
            <div v-else>
                <div class="col-7 col-7-s col-padding-left col-padding-left-xl m-mt10 m-p10 p10 popup-content">
                    <div class="title-4 line12 boldFont fontSmooth col-12 titleColor mt20 m-mt0" v-text="title"></div>
                    <div class="paragraph mt10 small" v-html="content">
                    </div>
                    <div class="col-12 mt20 mb10">
                        <a :href="buttonLink"
                            class="button blue centerText small w100p"
                            v-text="buttonText"
                        >
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import newsletterSubscribe from "./NewsletterSubscribe.vue";
import Errors from "../../errors";

export default {
    name: "ContentPopup",
    components: {newsletterSubscribe},
    props: {
        contentPopup: {
            type: Object,
            required: true,
        },
        page: {
            type: String,
            required: false,
        }
    },
    data() {
        return {
            isSending: false,
            isSend: false,
            isError: false,
            errors: new Errors(),
            form: {
                first_name: null,
                last_name: null,
                email: null,
                page: this.page,
            },

            title: '',
            content: '',
            contentAfter: '',
            buttonText: '',
            buttonLink: '',
            image: '',
            style: "background-image: url('"+this.contentPopup.imagePath+"')",
            showModal: false,
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        subscribeNewsletter() {
            this.isSending = true;

            axios.post(`/api/subscribe/newsletter/`, this.form)
            .then(response => {
                if (response.data.success === true) {
                    this.isSend = true;
                    this.isSending = false;
                } else {
                    this.isSend = false;
                }
            })
            .catch(error => {
                this.errors.record(error.response.data.errors);
                this.isSending = false;
            })
        },
        checkCookie(){
            let cookieName = 'popup_seen_' + this.contentPopup.id;
            let cookie = this.getCookie(cookieName);
            if(cookie == 1){
                return false;
            }

            return true;
        },
        getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
    },
    mounted() {
        this.title = this.contentPopup.translations[0].title;
        this.content = this.contentPopup.translations[0].content;
        this.contentAfter = this.contentPopup.translations[0].content_after;
        this.buttonText = this.contentPopup.translations[0].button_text;
        this.buttonLink = this.contentPopup.translations[0].button_link;
        this.image = this.contentPopup.translations[0].image_path;

        let vue = this;
        setTimeout(function(){
            vue.showModal = vue.checkCookie();
        }, 5000);
    }
}
</script>

<style scoped>

</style>
